import { useEventListener } from '@vueuse/core';
import type { Ref } from 'vue';

// Ctrl (ou Cmd) maintenu — port de `useCtrlHeld` (chrome/SubTabs.jsx), purement décoratif.
// `blur` : un Ctrl+clic emmène le focus ailleurs, le `keyup` n'arrive jamais. `mouseover` : les
// événements clavier ne traversent pas une frontière de fenêtre (popup ARC), l'état est resynchronisé
// au retour. Pas `useKeyModifier` (@vueuse) : il écoute `document`, ignore le `blur`, et sa resynchro
// souris est inerte sous happy-dom (pas de `getModifierState`).
export function useCtrlHeld (): { ctrlHeld: Ref<boolean> } {
  const ctrlHeld = ref(false);

  function sync (event: KeyboardEvent | MouseEvent): void { ctrlHeld.value = event.ctrlKey || event.metaKey; }

  useEventListener(window, ['keydown', 'keyup', 'mouseover'], sync);
  useEventListener(window, 'blur', () => { ctrlHeld.value = false; });

  return { ctrlHeld };
}
